import React, { useState, useEffect } from "react";
import Loading from "../components/Loading";
import FundRaisingMap from "../components/FundRaisingMap";
import LoadCountriesTaskFundRaising from "../tasks/LoadCountriesTaskFundRaising";
import ReactGA from 'react-ga';

const TRACKING_ID ="G-2D7RRR14SS";
ReactGA.initialize(TRACKING_ID);
ReactGA.pageview(window.location.pathname + window.location.search);


function EaseOfFundRaising() {
  const [countries, setCountries] = useState([]);

  //const legendItemsReverse = [...legendItems].reverse();

  const load = () => {
    console.log("load");
    const loadCountriesTask = new LoadCountriesTaskFundRaising();
    loadCountriesTask.load((countries) => setCountries(countries));
  };
  console.log(countries)

  useEffect(load, []);

  return (
    <div>
      {countries.length === 0 ? (
        <Loading />
      ) : (
        <div >
          <FundRaisingMap
 countries={countries} />
           
        </div>
      )}
    </div>
  );
};

export default EaseOfFundRaising